import gql from "graphql-tag"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullHomepage from "../../fragments/fullHomepage"

const query = gql`
  mutation UpdateHomepage($data: HomepageUpdateInput!) {
    updateHomepage(data: $data) {
      ...fullHomepage
    }
  }
  ${fullHomepage}
`

export const updateHomepageKey = getQueryNames(query)[0]

export default query
